import parseFileName from './parseFileName';

export const ACCEPTED_TYPES: Record<string, string> = {
  png: 'image/png',
  apng: 'image/apng',
  gif: 'image/gif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  webp: 'image/webp',
  webm: 'video/webm',
  mp4: 'video/mp4',
  mov: 'video/mov',
  svg: 'image/svg+xml',
  js: 'text/javascript',
  html: 'text/html',
  otf: 'font/otf',
  css: 'text/css',
  ttf: 'font/ttf',
  woff: 'font/woff',
  woff2: 'font/woff2',
  psd: 'image/vnd.adobe.photoshop',
  csv: 'text/csv',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  wav: 'audio/wav',
  mp3: 'audio/mp3',
  flac: 'audio/flac',
  ogg: 'audio/ogg',
  m4a: 'audio/m4a',
  srt: 'application/x-subrip',
};

export default function getFileFromLink(url: string, fileName: string) {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new File([blob], fileName, {
          type: ACCEPTED_TYPES[parseFileName(fileName).fileExtension ?? ''],
        }),
    );
}
